module.exports = __webpack_public_path__ + "static/media/Stock_Issues_Template_1.5c5348fe.png";